import { Address } from '@/application/shared/domain/Address';
import { AddressValidationResponse } from '@/application/shared/domain/AddressValidationResponse';
import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { UseCase } from '@/shared/application/UseCase';
import { ServicesApiResponse } from '@hfc/ui-core';

export class AddressValidationUseCase implements UseCase<Address, ServicesApiResponse<AddressValidationResponse>> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (address: Address): Promise<ServicesApiResponse<AddressValidationResponse>> {
    return await this.repository.validateAddress(address);
  }

}
